<template>
  <div class="check-list-box">
    <ul class="check-list">
      <li v-for="(c, i) in checkList" :key="c.type" :class="{ 'check-list-checking': c.checking }">
        <div class="check-icon">
          <img :src="c.icon">
        </div>
        <div class="check-result" v-if="isCheck(c.type)">
          <!-- <img :src="c.passIcon"
              v-if="isPass(c.type)"> -->
          <svg width="20px" v-if="isPass(c.type)" height="20px" viewBox="0 0 20 20" version="1.1"
            xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
            <!-- Generator: Sketch 55.2 (78181) - https://sketchapp.com -->
            <title>入会检测切图</title>
            <desc>Created with Sketch.</desc>
            <g id="页面-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
              <g id="入会检测切图" transform="translate(-520.000000, -230.000000)" fill="#3986EE"  class="main-color" fill-rule="nonzero">
                <g id="编组-3" transform="translate(520.000000, 230.000000)">
                  <path
                    d="M10,0 C4.49704142,0 0,4.49704142 0,10 C0,15.5029586 4.49704142,20 10,20 C15.5029586,20 20,15.5029586 20,10 C20,4.49704142 15.5029586,0 10,0 Z M15.8822016,7.46344063 L9.37408141,13.9715608 C9.07554379,14.2700984 8.59788359,14.329806 8.23963845,14.0909759 C8.17993093,14.0312684 8.12022341,14.0312684 8.06051587,13.9715608 L4.2989418,10.2099868 C3.94069666,9.85174162 3.94069666,9.25466635 4.2989418,8.89642121 C4.65718693,8.53817607 5.2542622,8.53817607 5.61250734,8.89642121 L8.71729865,12.0012125 L14.5686361,6.14987506 C14.9268812,5.79162992 15.5239565,5.79162992 15.8822016,6.14987506 C16.2404468,6.56782774 16.2404468,7.10519547 15.8822016,7.46344063 L15.8822016,7.46344063 Z"
                    id="形状"></path>
                </g>
              </g>
            </g>
          </svg>
          <img :src="c.nopassIcon" v-else>
        </div>
        <p class="check-name" v-if="!c.checking || c.type == 'checkres'">{{ c.name }}</p>
        <p class="check-name fontColor" v-if="c.checking && c.type != 'checkres'">{{ c.checkName }}</p>
        <div class="check-splitline" v-if="(i + 1) != checkList.length"></div>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'checkHeader',
  props: {
    type: String,
    errs: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      checkList: [],
    }
  },
  watch: {
    'type': {
      handler() {
        this.init()
      }
    }
  },
  computed: {
    VideoInputDeviceId() {
      return this.$store.getters.VideoInputDeviceId
    },
    AudioInputDeviceId() {
      return this.$store.getters.AudioInputDeviceId
    },
    AudioOutputDeviceId() {
      return this.$store.getters.AudioOutputDeviceId
    },
    isCheck() {
      return (type) => {
        let isCheck = false;
        if (this.type == 'mic' && type == 'camera') {
          isCheck = true
        }
        if (this.type == 'speaker' && (type == 'camera' || type == 'mic')) {
          isCheck = true
        }
        if (this.type == 'checkres' && (type == 'camera' || type == 'mic' || type == 'speaker')) {
          isCheck = true
        }
        return isCheck
      }
    },
    isPass() {
      return (name) => {
        return !this.errs.includes(name)
      }
    }
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      this.checkList = [];
      let checkType = ['camera', 'mic', 'speaker', 'checkres'];
      checkType.forEach((v) => {
        let checking = v == this.type ? true : false,
          passIcon = require("@/svg/check_pass.svg"),
          nopassIcon = require("@/svg/check_err.svg");
        this.checkList.push({ name: this.$t(`check['${v}']`), checkName: this.$t(`check['${v}checking']`), type: v, icon: require("@/svg/" + v + ".svg"), checking, passIcon, nopassIcon })
      })
    }
  },
}
</script>

<style scoped lang="scss">
.check-list-box {
  position: relative;

  &::after {
    content: "";
    position: absolute;
    left: 30px;
    right: 30px;
    bottom: 0;
    height: 1px;
    background-color: $purple-color;
    background-color: rgba($color: $purple-color, $alpha: .6);
    transform: scaleY(.5);
  }
}

.check-list {
  margin: auto;
  width: 582px;
  height: 134px;
  display: flex;
  justify-content: space-around;
  align-items: center;
  padding-bottom: 16px;
  box-sizing: border-box;

  li {
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 60px;
    white-space: nowrap;

    .check-icon {
      width: 60px;
      height: 60px;
      background-color: $purple-color;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .check-result {
      position: absolute;
      right: 0px;
      bottom: 0px;
    }

    .check-name {
      color: $gray6-color;
      font-size: 14px;
      position: absolute;
      width: max-content;
      margin: auto;
      top: 68px;
    }

    .check-splitline {
      width: 84px;
      position: absolute;
      height: 1px;
      left: 60px;
      border-top: 1.5px dashed $purple-color;
      top: 30px;
    }
  }

  .check-list-checking {
    .check-icon {
      background-color: $bule-color;
    }

    .check-name {
      color: $white-color;
    }
  }
}</style>